import { useMemo } from "react";

/**
 * 
 * @param {*} props
 * detail : string => object key of _details the field is part of
 * index : int => since _details is an array. This tells us to which this field belongs to
 * @returns 
 */
export const DateField = (props) =>{
    const {fieldName, fieldConfig, onChange, detail, index, ...prop} = props;
    const handleFieldChange= (value, e) =>{
        if(!value || value.length === 0)
            value = null;
        if(onChange)
            onChange(value, fieldName, {fieldConfig, detail, index, e});
    }
    
    const settings = useMemo(() => {
        const ret = {
            Mandatory : false, 
            Type : "date",
            Value : null,
            ...fieldConfig
        }
        if(fieldConfig.Value && fieldConfig.Value.indexOf("T") > -1)
            ret.Value = fieldConfig.Value.split("T")[0];

        return ret;
    }, [fieldConfig])
    return (
        <>
        <input 
          type= {settings.Type}
          name={fieldName}
          required={settings.Mandatory}
          key={fieldName}
          defaultValue={settings.Value}
          {...prop}
          onChange={(e) => {
            handleFieldChange(e.target.value, e);
          }}
          placeholder={settings.Trans?.Placeholder || ""}></input>
          </>
    )
}